import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';


const BottomTabNavigation = () => {
  const location = useLocation();
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [userRole, setUserRole] = useState(null);
  const [activeDealCount, setActiveDealCount] = useState(0);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const role = localStorage.getItem('userRole');
    const dealCount = parseInt(localStorage.getItem('activeDealCount') || '0', 10);
    const savedLanguage = localStorage.getItem('language') || 'en';
    const userData = JSON.parse(localStorage.getItem('user') || 'null');

    setUserRole(role);
    setActiveDealCount(dealCount);
    setCurrentLanguage(savedLanguage);
    setUser(userData);
  }, []);

  const translations = {
    en: {
      dashboard: 'Dashboard',
      deals: 'Deals',
      profile: 'Profile'
    },
    ko: {
      dashboard: '대시보드',
      deals: '거래',
      profile: '프로필'
    }
  };

  const t = translations?.[currentLanguage];

  const navigationItems = [
    {
      label: t?.dashboard,
      path: '/unified-dashboard',
      icon: 'LayoutDashboard',
      roles: ['buyer', 'traveler', 'admin']
    },
    {
      label: currentLanguage === 'en' ? 'My Trips' : '내 여행',
      path: '/traveler-trip-creation',
      icon: 'Plane',
      roles: ['traveler', 'admin']
    },
    {
      label: t?.deals,
      path: '/deal-room-page',
      icon: 'Handshake',
      roles: ['buyer', 'traveler', 'admin'],
      badge: activeDealCount > 0 ? activeDealCount : null
    },
    {
      label: t?.profile,
      path: user?.id ? `/traveler-profile/${user?.id}` : '/profile',
      icon: 'User',
      roles: ['buyer', 'traveler', 'admin']
    }
  ];

  const visibleNavItems = navigationItems?.filter(item => 
    !item?.roles || (userRole && item?.roles?.includes(userRole))
  );

  const isActive = (path) => location?.pathname === path;

  return (
    <nav className="fixed bottom-0 left-0 right-0 h-14 bg-card border-t border-border z-100 lg:hidden">
      <div className="h-full flex items-center justify-around px-2">
{visibleNavItems?.map((item, index) => (
  <Link
    key={item?.path}
    to={item?.path}
    className={`relative flex flex-col items-center justify-center flex-1 h-full transition-base ${
      isActive(item?.path) ? 'text-primary' : 'text-muted-foreground'
    }`}
  >
    <div className="relative">
  <img
    src="/assets/images/ogada-logo-1770865214464.png"
    alt="OGADA"
    className="w-6 h-6 object-contain"
  />
  {item?.badge && (
    <span className="absolute -top-2 -right-2 w-5 h-5 bg-accent text-accent-foreground text-xs font-bold rounded-full flex items-center justify-center">
      {item?.badge}
    </span>
  )}
</div>
    <span className="text-xs font-medium mt-1 caption">{item?.label}</span>
  </Link>
))}        
      </div>
    </nav>
  );
};

export default BottomTabNavigation;